import React from 'react';
import styles from './HomeScreen.module.scss';
import Section1 from './section1/Section1';
import Section2 from './section2/Section2';
import Footer from '../footer/Footer';
import Section3 from './section3/Section3';
import Section5 from './section5/Section5';
import Section4 from './section4/Section4';
import WinnersSection from './winners/Winners';

const HomeScreen = () => {
  // const deviceInfo = useState(getDeviceInfo(window.innerWidth, window.innerHeight));
  // select the favicon
  const faviconEl = document.querySelector('link[rel="icon"]');
  // watch for changes
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  mediaQuery.addEventListener('change', themeChange);

  // listener
  function themeChange(event) {
    faviconEl.setAttribute(
      'href',
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/favicon.ico'
    );
  }
  return (
    <>
      <div className={`home-container ${styles.homeContainer} overflow-y-scroll`}>
        {/* body */}
        <div className={`${styles.section1Container}`}>
          <Section1 />
        </div>
        <div className={`${styles.section2Container}`}>
          <div className={`${styles.section2SubContainer}`}>
            <Section2 />
            <WinnersSection />
          </div>
          <Section3 />
          <Section4 />
        </div>
        <div className={`${styles.section5Container}`}>
          <Section5 />
        </div>
        {/* footer */}
        <Footer />
      </div>
    </>
  );
};

export default HomeScreen;
